import { PaginateQuery } from 'core/resources/types/shared';
import axios from "infra/http";
import { useQuery } from "react-query";
import { ListaConvidadosPortaria } from "../typings/index";
import { PaginateResult } from "resources/types/shared";

function useListaConvidadosEvento(
  id?: string,
  params?: PaginateQuery,
  enabled?: boolean,
) {
  return useQuery(
    [`/v1/portaria/${id}/pessoas`, params],
    async () => {
      const { data } = await axios.get<PaginateResult<ListaConvidadosPortaria>>(
        `/v1/evento/${id}/pessoas`,
        { params }
      );

      return data;
    },
    {
      enabled,
    }
  );
}

export default useListaConvidadosEvento;
